import { Kursushold } from "../../../../interfaces/schema";
import { defaultIfNullish } from "../../../../util/stringUtil";
import ListItem from "../../../ListItem";
import { SidebarContainer } from "../../../SidebarContainer";
import { Link } from "react-router-dom";

export default function Sidebar({ kursushold }: { kursushold: Kursushold }) {
  return (
    <SidebarContainer>
      <ListItem
        label="Kategori"
        value={defaultIfNullish(
          kursushold.fmukursusKategoriNavigation?.navn ?? "",
        )}
      />
      <ListItem label="Kursusnr." value={defaultIfNullish(kursushold.holdNr)} />
      <ListItem
        label="Linje"
        value={
          <>
            {kursushold.fmulinje && (
              <Link
                className="link-primary"
                to={`/linje/${kursushold.fmulinjeId}`}
              >
                {kursushold.fmulinje.navn}
              </Link>
            )}
            {!kursushold.fmulinje && "-"}
          </>
        }
      />
      <ListItem
        label="Hotel"
        value={defaultIfNullish(kursushold.hotelNavigation?.navn1)}
      />
      <ListItem
        label="Varighed"
        value={defaultIfNullish(kursushold.varighed)}
      />
      <ListItem
        label="Antal deltagere fra linje"
        value={defaultIfNullish(kursushold.antalTilmeldteFraLinje)}
      />
      <ListItem
        label="Antal deltagere i alt"
        value={defaultIfNullish(kursushold.antalTilmeldte)}
      />
    </SidebarContainer>
  );
}
